"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ApiService = /*#__PURE__*/function (_Service) {
  (0, _inherits2.default)(ApiService, _Service);
  function ApiService() {
    (0, _classCallCheck2.default)(this, ApiService);
    return _callSuper(this, ApiService, arguments);
  }
  (0, _createClass2.default)(ApiService, [{
    key: "getCheckList",
    value:
    // [审核管理]获取分页列表
    function getCheckList(param) {
      return this.http.get("/admin/activity/promo_apply/page_list?".concat(_qs.default.stringify(param)));
    }
    // [审核管理]审核
  }, {
    key: "changeStatus",
    value: function changeStatus(data) {
      return this.http.post("/admin/activity/promo_apply/change_status", data);
    }
  }]);
  return ApiService;
}(_serviceBase.default);
var _default = exports.default = new ApiService();